import TextField from "@mui/material/TextField";
import {MenuItem, Select, Stack} from "@mui/material";
import {Phone, PhoneLocationType, PhoneType} from "crqlar-react-common/dist/models/profile/phone.model";
import * as React from "react";
import {useTranslation} from "react-i18next";
import Property from "crqlar-react-common/dist/components/Property";

interface Props {
    phone: Phone
    setPhone: (phone: Phone) => void
    index: number
    managedExternally: boolean
}

const PhoneField = (props: Props) => {

    const {t} = useTranslation()

    return (
        <Stack direction={'column'} gap={1} width={'100%'}>
            <Property title={t('Phone number')} labelAlignment={'top'}>
                <TextField
                    id={`phone-${props.index}`}
                    size={'small'}
                    value={props.phone.phoneNumberFull}
                    onChange={(e) => {
                        props.setPhone({
                            ...props.phone,
                            phoneNumberFull: e.target.value
                        })
                    }}
                    fullWidth
                    disabled={props.managedExternally}
                />
            </Property>

            <Property title={t('Phone number type')} labelAlignment={'top'}>
                <Stack
                    sx={{
                        width: '100%',
                    }}
                >
                    <Select
                        id={`phone-type-${props.index}`}
                        variant={'outlined'}
                        value={props.phone.phoneType}
                        onChange={(e) => {
                            props.setPhone({
                                ...props.phone,
                                phoneType: e.target.value as PhoneType
                            })
                        }}
                        size={'small'}
                        disabled={props.managedExternally}
                        fullWidth
                    >
                        {
                            Object.values(PhoneType).map((type, index) => (
                                <MenuItem
                                    key={index}
                                    value={type}
                                    id={`phone-type-${type}`}
                                >
                                    {type ? t(`Phone Type ${type}`) : t('(Not set)')}
                                </MenuItem>
                            ))
                        }
                    </Select>

                </Stack>
            </Property>

            {
                props.managedExternally &&
                <Property title={t('PMS type')} labelAlignment={'top'}>
                    <TextField
                        value={props.phone.phoneTypeOTA}
                        size={'small'}
                        disabled
                        fullWidth
                    />
                </Property>
            }

            <Property title={t('Remark')} labelAlignment={'top'}>
                <TextField
                    id={`phone-remark-${props.index}`}
                    size={'small'}
                    value={props.phone.remark || ''}
                    onChange={(e) => {
                        props.setPhone({
                            ...props.phone,
                            remark: e.target.value
                        })
                    }}
                    fullWidth
                    disabled={props.managedExternally}
                />
            </Property>


            <Property title={t('Location')} labelAlignment={'top'}>
                <Select
                    id={`phone-location-${props.index}`}
                    variant={'outlined'}
                    value={props.phone.phoneLocationType}
                    onChange={(e) => {
                        props.setPhone({
                            ...props.phone,
                            phoneLocationType: e.target.value
                        })
                    }}
                    size={'small'}
                    disabled={props.managedExternally}
                    fullWidth
                >
                    {
                        Object.keys(PhoneLocationType).map((type, index) => (
                            <MenuItem
                                key={index}
                                value={type}
                                id={`phone-location-${type}`}
                            >
                                {type ? t(`Phone Location Type ${type}`) : t('(Not set)')}
                            </MenuItem>
                        ))
                    }
                </Select>
            </Property>

        </Stack>
    )
}

export default PhoneField;
